// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__25P25","close":"sidebar_close__3Q2xI"};